<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn :disabled="(clients.length === 0)" icon :to="{ name: 'called-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>
      <v-card class="pa-3">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-select
              :items="clients"
              v-model="client_id"
              item-text="name"
              item-value="id"
              clearable
              :disabled="disabledClient || (clients.length === 0)"
              label="Selecione um cliente">
            </v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="projects"
              v-model="project_id"
              item-text="name"
              item-value="id"
              clearable
              :disabled="!client_id || projects.length === 0"
              label="Selecione um projeto">
            </v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="calledStatus"
              v-model="called_status_id"
              item-text="description"
              item-value="id"
              clearable
              label="Selecione um status">
            </v-select>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              name="term"
              label="Pesquise por termos no chamado"
              v-model="term"></v-text-field>
          </v-flex>
          <v-flex xs12 md12 text-md-center>
            <v-alert
              :value="showAlert"
              type="error">
              Não existem clientes cadastrados no sistema.
            </v-alert>
            <v-btn :disabled="(clients.length === 0)" flat color="primary" @click="search()">
              <v-icon>search</v-icon>
              Pesquisar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">
          <td>
            #{{ props.item.id }}
          </td>
          <td>
            {{ props.item.title }}
          </td>
          <td>
            {{ props.item.project.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.priority.description }}
          </td>
          <td>
            {{ props.item.cycle.name }}
          </td>
          <td class="text-xs-center">
            {{ cycleStatus[props.item.cycle.active] }}
          </td>
          <td>
            {{ props.item.called_users[0].user.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.called_status.description }}
          </td>
          <td class="text-xs-center">

            <v-tooltip top>
              <template slot="activator">
                <v-btn
                  color="primary"
                  flat
                  icon
                  v-clipboard="props.item.id"
                  @success="handleSuccess"
                  @error="handleError">
                  <v-icon>content_copy</v-icon>
                </v-btn>
              </template>
              <span>Copiar Número</span>
            </v-tooltip>

            <v-tooltip top>
              <template slot="activator">
                <v-btn color="primary" flat icon @click="followCalled(props.item.id)">
                  <v-icon>search</v-icon>
                </v-btn>
              </template>
              <span>Visualizar</span>
            </v-tooltip>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import axios from 'axios';
import { find as _find } from 'lodash';
import CrudMixin from '@/components/mixins/CrudMixin';
import CalledService from '@/features/called/CalledService';
import ClientService from '@/features/client/ClientService';
import ProjectService from '@/features/project/ProjectService';
import CalledStatusService from '@/features/called-status/CalledStatusService';
import UserService from '@/features/user/UserService';

export default {
  name: 'called-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo',
      },
      headers: [
        {
          text: this.$t('attributes.called.number'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.title'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.project'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.priority'),
          sortable: false,
          align: 'center',
        },
        {
          text: this.$t('attributes.called.cycle'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.cycle_status'),
          sortable: false,
          align: 'center',
        },
        {
          text: this.$t('attributes.called.createBy'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.status'),
          sortable: false,
          align: 'center',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'center',
        },
      ],
      clientService: new ClientService(),
      projectService: new ProjectService(),
      calledStatusService: new CalledStatusService(),
      clients: [],
      client_id: null,
      projects: [],
      project_id: null,
      calledStatus: [],
      called_status_id: null,
      term: null,
      disabledClient: false,
      showAlert: false,
    };
  },
  watch: {
    client_id(value) {
      if (value) {
        const params = {
          client_id: value,
        };
        this.projectService.query(params).then((projects) => {
          if (projects.length > 0) {
            this.projects = projects;
          } else {
            this.project_id = null;
            this.projects = [];
          }
        });
      }
    },
  },
  created() {
    const user = this.$store.state.currentUser;
    if (!UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.client_id = (user && user.client) ? user.client.id : null;
      this.disabledClient = true;
    }
    this.loadCombos();
  },
  methods: {
    initCrud() {
      this.serviceType = CalledService;
      this.routerName = 'called';
      this.onSearchInit = false;
    },
    applyFilters(filter) {
      const params = {
        client_id: this.client_id,
        project_id: this.project_id,
        called_status_id: this.called_status_id,
        term: this.term,
      };
      return Object.assign(filter, params);
    },
    followCalled(calledId) {
      const params = { id: calledId };
      this.$router.push({ name: 'follow-called', params });
    },
    setDefaultCalledStatus() {
      const status = _find(this.calledStatus, { slug: 'aberto' });
      if (status) {
        this.called_status_id = status.id;
      }
    },
    async loadCombos() {
      const request = [
        this.clientService.query(),
        this.calledStatusService.query(),
      ];
      axios.all(request).then(axios.spread((clients, calledStatus) => {
        this.clients = clients;
        this.calledStatus = calledStatus;
        if (this.clients.length === 0) {
          this.showAlert = true;
        } else {
          this.showAlert = false;
          this.setDefaultCalledStatus();
          this.search();
        }
      }));
    },
    handleSuccess() {
      this.$toast.success('Chamado copiado com sucesso!');
    },
    handleError() {
      this.$toast.error('Erro ao tentar copiar o chamado, tente novamente.');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/called/CalledList.vue